/* ----------------------------------- */
// Domain import pattern. Please       //
// follow below usage for all reducers //
/* ----------------------------------- */

import initialState from "./initial";
import * as Types from "../actions/types";
import { createReducer } from "redux-immutablejs";
import { fromJS } from "immutable";

const initial = fromJS(initialState.account);

const account = createReducer(initial, {
  [Types.LOGIN_RESULT]: (state, action) => 
    state.merge({
        email               : action.payload.data.userEmail,
        nameSurname         : action.payload.data.userNameuserSurname,
        auth                : state.get('auth').merge({
            isLoggedIn          : action.payload.data.isLoggedIn,
            isAuth              : action.payload.data.isAuth,
            loginTime           : action.payload.data.loginTime,
            token               : action.payload.data.token
        }),
    }),
});

export default account;
